import { FC } from 'react';

import { Input, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';

type Props = {
  inputRef: React.RefObject<HTMLInputElement>;
  value: string;
  onChange: (value: string) => void;
};

export const SearchModalHeader: FC<Props> = ({ inputRef, value, onChange }) => {
  return (
    <div className="flex-shrink-0 w-full h-14 px-4 flex flex-nowrap items-center">
      <div className="z-0 relative flex flex-nowrap items-center w-full">
        <Icon
          glyph={IconMap.SearchLg}
          width={20}
          className="absolute z-10 text-gray-500"
        />
        <Input
          ref={inputRef}
          onKeyDown={(e) => {
            if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
              e.preventDefault();
            }
          }}
          type="text"
          placeholder="Start typing to search ..."
          isFullHeight
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="!pl-7 !pr-6 !py-2.5 !text-md !h-full !text-gray-900 font-medium placeholder:font-normal !shadow-none !border-none"
          id="modal-search"
        />
        {value && (
          <Icon
            glyph={IconMap.XCircle}
            width={20}
            className="absolute right-0 z-10 text-gray-700 cursor-pointer"
            onClick={() => onChange('')}
          />
        )}
      </div>
    </div>
  );
};
